import { render } from "./ModalGallery.vue?vue&type=template&id=70ef13a2&scoped=true"
import script from "./ModalGallery.vue?vue&type=script&lang=js"
export * from "./ModalGallery.vue?vue&type=script&lang=js"

import "./ModalGallery.vue?vue&type=style&index=0&id=70ef13a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ef13a2"]])

export default __exports__